import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Field.st.css';
import { FieldProps } from './Field.types';

const Field = ({
  noPadding = false,
  divider = 'auto',
  children,
}: FieldProps) => {
  return (
    <div
      className={st(classes.root, {
        padded: !noPadding,
        divider: String(divider),
      })}
    >
      {children}
    </div>
  );
};

Field.displayName = 'Field';

Field.propTypes = {
  noPadding: PropTypes.bool,
  divider: PropTypes.oneOf([PropTypes.bool, 'auto']),
  children: PropTypes.node,
};

export default Field;
